import React, { useContext, useReducer } from "react";
// import axios from "axios";
import axios from "../../../axiosinstance";
import Moment from "moment";
import DashboardContext from "./DashboardContext";
import DashboardReducer from "./DashboardReducer";
import {
  GET_FACEBOOK_PROFILES,
  FILTER_PROFILES,
  CLEAR_FILTERED_PROFILES,
  SET_PROFILE,
  SELECTED_PROFILE,
  SELECTED_FACEBOOK_DETAILS,
  SET_TOGGLE_ADS,
  SET_DISPLAY_CONTENT,
  SET_CURRENT_TAB,
  STATS_FILTER,
  CAMPAIGN_DETAILS,
  ADSET_DETAILS,
  AD_DETAILS,
  CAMPAIGN_FILTERED,
  ADSET_FILTERED,
  AD_FILTERED,
  CAMPAIGN_SELECTED,
  ADSET_SELECTED,
  AD_SELECTED,
  GET_PROFILE_ERROR,
  FACEBOOK_PROFILES_ERROR,
} from "../../types";
import qs from "query-string";

// Contexts
import AuthContext from "../../auth/AuthContext";
import LayoutContext from "../../layout/LayoutContext";

const DashboardState = (props) => {
  // Today's Date
  let today = Moment(new Date(), "YYYY-MM-DD");
  today = today.format();
  today = today.substring(0, today.indexOf("T"));

  const initialState = {
    profiles: null,
    profiles_filtered: null,
    profile_form: {
      action: "",
      profile_id: "",
      access_token: "",
    },

    selected_profile: null,
    selected_fb_details: {
      id: null,
      business_manager: null,
      ad_account: null,
      pixel: "",
    },
    facebook_errors: null,

    toggle_ads: true,
    display_content: null,
    current_tab: "Campaign",

    stats_date_filter: {
      start_date: today,
      end_date: today,
      name: "Today",
    },
    stats_delivery_filter: {
      Campaign: "ALL",
      "Ad Set": "ALL",
      Ad: "ALL",
    },
    stats_name_filter: {
      Campaign: "",
      "Ad Set": "",
      Ad: "",
    },

    campaign_stats: [],
    adset_stats: [],
    ad_stats: [],
    campaign_filtered: [],
    adset_filtered: [],
    ad_filtered: [],
    campaign_selected: [],
    adset_selected: [],
    ad_selected: [],

    // profile_fb_camp: null,
    // profile_fb_adset: null,
    // profile_fb_ad: null,
    // selected_fb_tab: "campaign",

    profiles_error: null,
  };

  const [state, dispatch] = useReducer(DashboardReducer, initialState);
  const { user } = useContext(AuthContext);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const getStatusText = (number) => {
    let status = "";

    if (number === 1) status = "ACTIVE";
    else if (number === 2) status = "DISABLED";
    else if (number === 3) status = "UNSETTLED";
    else if (number === 7) status = "PENDING_RISK_REVIEW";
    else if (number === 8) status = "PENDING_SETTLEMENT";
    else if (number === 9) status = "IN_GRACE_PERIOD";
    else if (number === 100) status = "PENDING_CLOSURE";
    else if (number === 101) status = "CLOSED";
    else if (number === 201) status = "ANY_ACTIVE";
    else if (number === 202) status = "ANY_CLOSED";

    return status;
  };

  const getProfiles = async () => {
    try {
      const res = await axios.get("/api/facebook_profile/id");

      dispatch({
        type: GET_FACEBOOK_PROFILES,
        payload: res.data,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: FACEBOOK_PROFILES_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const filterProfiles = (text) => {
    dispatch({
      type: FILTER_PROFILES,
      payload: text,
    });
  };

  const clearFilteredProfiles = () => {
    dispatch({
      type: CLEAR_FILTERED_PROFILES,
    });
  };

  const getProfile = async (id) => {
    if (!state.selected_profile || state.selected_profile.profile_id !== id) {
      setLoading(true);

      try {
        const res = await axios.get(`/api/facebook_profile/${id}`);
        getProfiles();

        dispatch({
          type: SELECTED_PROFILE,
          payload: res.data,
        });
      } catch (err) {
        console.log(err);
        dispatch({
          type: FACEBOOK_PROFILES_ERROR,
          payload: err.response.msg,
        });
      }

      setLoading(false);
    }
  };

  const setProfile = async (profile) => {
    dispatch({
      type: SET_PROFILE,
      payload: profile,
    });
  };

  const createProfile = async (profile) => {
    setLoading(true);
    profile["username"] = user.name;

    try {
      const res = await axios.post(`/api/facebook_profile/create`, profile);

      dispatch({
        type: SELECTED_PROFILE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FACEBOOK_PROFILES_ERROR,
        payload: err.response.data,
      });
    }

    setLoading(false);
  };

  const editProfile = async (old_profile_id, profile) => {
    setLoading(true);
    profile["username"] = user.name;

    try {
      const res = await axios.put(
        `/api/facebook_profile/${old_profile_id}`,
        profile
      );

      dispatch({
        type: SELECTED_PROFILE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FACEBOOK_PROFILES_ERROR,
        payload: err.response.data,
      });
    }

    setLoading(false);
  };

  const deleteProfile = async () => {
    setLoading(true);

    const profile = state.selected_profile;

    try {
      const res = await axios.delete(
        `/api/facebook_profile/${profile.profile_id}`
      );

      setAlert(`${res.data.msg}.`, "success");

      setTimeout(() => {
        window.location.replace(`${window.location.origin}/facebook/profile`);
      }, 1000);
    } catch (err) {
      setAlert(err.response.data.msg, "error");
    }

    setLoading(false);
  };

  const setSelectedFacebookDetails = (details) => {
    dispatch({
      type: SELECTED_FACEBOOK_DETAILS,
      payload: details,
    });
  };

  const setToggleAds = (text) => {
    let value = text ? text : !state.toggle_ads;
    dispatch({
      type: SET_TOGGLE_ADS,
      payload: value,
    });
  };

  const setDisplayContent = (page) => {
    dispatch({
      type: SET_DISPLAY_CONTENT,
      payload: page,
    });
  };

  const setCurrentTab = (tab) => {
    dispatch({
      type: SET_CURRENT_TAB,
      payload: tab,
    });
  };

  const setStatsFilter = (filter, data) => {
    let info;

    if (filter === "stats_date_filter") {
      const start_date = data.startDate;
      const end_date = data.endDate;

      const start = start_date ? start_date : today;
      const end = end_date ? end_date : today;
      let name = "Today";

      if (start_date && end_date) name = "Yesterday";

      info = [start, end, name];
    } else if (filter === "stats_delivery_filter") {
      const tab = data.current_tab ? data.current_tab : "ALL";
      const status = data.status ? data.status : "ALL";

      info = [tab, status];
    } else if (filter === "stats_name_filter") {
      const tab = data.current_tab ? data.current_tab : "ALL";
      const text = data.text ? data.text : "";

      info = [tab, text];
    }

    dispatch({
      type: STATS_FILTER,
      payload: [filter, info],
    });
  };

  const getCampaignStats = async (profile) => {
    if (profile) {
      const params = {
        profile_id: profile.profile_id,
        ad_account_id: state.selected_fb_details.ad_account,
        start_date: state.stats_date_filter.start_date,
        end_date: state.stats_date_filter.end_date,
        delivery_status: state.stats_delivery_filter.Campaign,
      };

      const params_encoded = qs.stringify(params, {
        arrayFormat: "comma",
      });

      try {
        const res = await axios.get(
          `/api/facebook_campaign/stats?${params_encoded}`
        );

        dispatch({
          type: CAMPAIGN_DETAILS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: CAMPAIGN_DETAILS,
          payload: [],
        });
      }
    } else {
      dispatch({
        type: CAMPAIGN_DETAILS,
        payload: [],
      });
    }
  };

  const getAdSetStats = async (profile) => {
    if (profile) {
      const campaign_selected = state.campaign_selected.filter((n) => {
        if (n) return n;
      });

      const params = {
        profile_id: profile.profile_id,
        ad_account_id: state.selected_fb_details.ad_account,
        start_date: state.stats_date_filter.start_date,
        end_date: state.stats_date_filter.end_date,
        campaign_selected: JSON.stringify(campaign_selected),
        delivery_status: state.stats_delivery_filter["Ad Set"],
      };

      const params_encoded = qs.stringify(params, {
        arrayFormat: "comma",
      });

      try {
        const res = await axios.get(
          `/api/facebook_adset/stats?${params_encoded}`
        );

        dispatch({
          type: ADSET_DETAILS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: ADSET_DETAILS,
          payload: [],
        });
      }
    } else {
      dispatch({
        type: ADSET_DETAILS,
        payload: [],
      });
    }
  };

  const getAdStats = async (profile) => {
    if (profile) {
      const campaign_selected = state.campaign_selected.filter((n) => {
        if (n) return n;
      });
      const adset_selected = state.adset_selected.filter((n) => {
        if (n) return n;
      });

      const params = {
        profile_id: profile.profile_id,
        ad_account_id: state.selected_fb_details.ad_account,
        start_date: state.stats_date_filter.start_date,
        end_date: state.stats_date_filter.end_date,
        campaign_selected: JSON.stringify(campaign_selected),
        adset_selected: JSON.stringify(adset_selected),
        delivery_status: state.stats_delivery_filter["Ad"],
      };

      const params_encoded = qs.stringify(params, {
        arrayFormat: "comma",
      });

      try {
        const res = await axios.get(`/api/facebook_ad/stats?${params_encoded}`);

        dispatch({
          type: AD_DETAILS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: AD_DETAILS,
          payload: [],
        });
      }
    } else {
      dispatch({
        type: AD_DETAILS,
        payload: [],
      });
    }
  };

  const getCampaignFiltered = () => {
    const text = state.stats_name_filter["Campaign"];

    dispatch({
      type: CAMPAIGN_FILTERED,
      payload: text,
    });
  };

  const getAdSetFiltered = () => {
    const text = state.stats_name_filter["Ad Set"];

    dispatch({
      type: ADSET_FILTERED,
      payload: text,
    });
  };

  const getAdFiltered = () => {
    const text = state.stats_name_filter["Ad"];

    dispatch({
      type: AD_FILTERED,
      payload: text,
    });
  };

  const setCampaignSelected = (list) => {
    dispatch({
      type: CAMPAIGN_SELECTED,
      payload: list,
    });
  };

  const setAdsetSelected = (list) => {
    dispatch({
      type: ADSET_SELECTED,
      payload: list,
    });
  };

  const setAdSelected = (list) => {
    dispatch({
      type: AD_SELECTED,
      payload: list,
    });
  };

  const getFacebookError = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/facebook_profile/error");

      dispatch({
        type: GET_PROFILE_ERROR,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FACEBOOK_PROFILES_ERROR,
        payload: err.response,
      });
    }
    setLoading(false);
  };

  const clearProfilesError = () => {
    dispatch({
      type: FACEBOOK_PROFILES_ERROR,
      payload: null,
    });
  };

  return (
    <DashboardContext.Provider
      value={{
        profiles: state.profiles,
        profiles_filtered: state.profiles_filtered,
        profile_form: state.profile_form,

        selected_profile: state.selected_profile,
        selected_fb_details: state.selected_fb_details,
        facebook_errors: state.facebook_errors,

        toggle_ads: state.toggle_ads,
        display_content: state.display_content,
        current_tab: state.current_tab,

        stats_date_filter: state.stats_date_filter,
        stats_delivery_filter: state.stats_delivery_filter,
        stats_name_filter: state.stats_name_filter,

        campaign_stats: state.campaign_stats,
        adset_stats: state.adset_stats,
        ad_stats: state.ad_stats,
        campaign_filtered: state.campaign_filtered,
        adset_filtered: state.adset_filtered,
        ad_filtered: state.ad_filtered,
        campaign_selected: state.campaign_selected,
        adset_selected: state.adset_selected,
        ad_selected: state.ad_selected,

        profiles_error: state.profiles_error,

        getStatusText,
        getProfiles,
        filterProfiles,
        clearFilteredProfiles,
        getProfile,
        setProfile,

        createProfile,
        editProfile,
        deleteProfile,

        setSelectedFacebookDetails,

        setToggleAds,
        setDisplayContent,
        setCurrentTab,

        setStatsFilter,
        getCampaignStats,
        getAdSetStats,
        getAdStats,
        getCampaignFiltered,
        getAdSetFiltered,
        getAdFiltered,
        setCampaignSelected,
        setAdsetSelected,
        setAdSelected,

        getFacebookError,
        clearProfilesError,
      }}
    >
      {props.children}{" "}
    </DashboardContext.Provider>
  );
};

export default DashboardState;
